import React, { useEffect, useState } from "react";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { useParams } from "react-router-dom";
import Spinner from "../../components/spinner/Spinner";

interface IContract {
  id: string;
  key: string;
  value: string;
  createdAt: string;
  updatedAt: string;
  status: boolean;
}

const Contracts: React.FC = () => {
  const [contractsData, setContractsData] = useState<IContract[]>([]);
  // const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const { contractType } = useParams();
  // const navigate = useNavigate();

  useEffect(() => {
    const fetchAllContracts = async () => {
      setLoading(true);
      try {
        const response = await getFetcher(endpoints.auth.getContracts);
        if (response.result) {
          setContractsData(response.contracts);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchAllContracts();
  }, []);

  // Dynamically get the contract based on `contractType`
  const currentContract = contractsData.find(
    (contract) => contract.key === contractType
  );

  // const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setIsChecked(e.target.checked);
  // };

  // const handleSubmit = (contractType: string | undefined) => {
  //   if (isChecked) {
  //     if (contractType) {
  //       switch (contractType) {
  //         case "kvkk-supplier":
  //           navigate("/supplier-application-form");
  //           break;
  //         case "privacy_and_security_policy":
  //           navigate("/register");
  //           break;
  //         case "distance_selling_contract":
  //           navigate("/register");
  //           break;
  //         case "privacy_and_security_policy-google":
  //           navigate("/registerGoogle");
  //           break;
  //         case "privacy_and_security_policy-facebook":
  //           navigate("/registerFacebook");
  //           break;
  //         default:
  //           navigate("/");
  //           break;
  //       }
  //     } else {
  //       navigate("/");
  //     }
  //   } else {
  //     alert("Lütfen onaylayın.");
  //   }
  // };

  if (loading) {
    return <div><Spinner /></div>
  }

  const formattedContract = currentContract
    ? currentContract.value
      .split('\n') // Satır sonlarına göre böl
      .map((line, index) => `<p style="text-align: justify; margin-bottom: 10px;" key=${index}>${line}</p>`)
      .join('') // Tekrar birleştir
    : "";

  return (
    <div className=" min-h-screen flex justify-center items-center">
      <div className="w-10/12 rounded shadow-xl shadow-gray-300 bg-gray-100 mx-auto p-4 py-10 my-4 flex justify-center items-center flex-col gap-y-5">
        <div className=" w-full flex  flex-col gap-y-5">
          <div className="flex justify-center items-center">
            <h1 className="font-bold text-xl">
              {/* {currentContract ? currentContract.key.replace(/-/g, ' ').toUpperCase() : "Sözleşme Bulunamadı"} */}
            </h1>
          </div>

          <div className="h-[500px] overflow-y-auto">
            <div
            className="text-"
              dangerouslySetInnerHTML={{ __html: formattedContract }}
            />
          </div>

          {/* <div className="my-4 flex flex-col justify-center items-center gap-y-4">
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className="form-checkbox h-4 w-4"
              />
              <span>Onaylıyorum, sözleşmeyi kabul ediyorum.</span>
            </label>

            <button
              onClick={() => handleSubmit(contractType)}
              disabled={!isChecked}
              className={`mt-4 px-4 py-2 rounded ${
                isChecked ? 'bg-primary-color text-white' : 'bg-gray-300 text-gray-700'
              }`}
            >
              Gönder
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Contracts;
